export default __webpack_public_path__ + "static/media/element_32.6f0358ba.webp";